import {CSSProperties} from 'react';

export const PurpleTag = ({
  width = 16,
  height = 16,
  style,
  className
}: {
  width?: number;
  height?: number;
  style?: CSSProperties;
  className?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      style={style}
      className={className}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6" cy="6" r="5.65297" fill="url(#paint0_linear_1494_2789)" stroke="white" strokeWidth="0.694056" />
      <path
        d="M2.72839 6.21672L5.34841 3.5967C5.38746 3.55733 5.43396 3.52612 5.48518 3.50488C5.5364 3.48363 5.59134 3.47279 5.64679 3.47296H8.09216C8.14814 3.47296 8.20182 3.4952 8.2414 3.53478C8.28098 3.57436 8.30322 3.62805 8.30322 3.68402V6.12939C8.3034 6.18484 8.29255 6.23978 8.27131 6.291C8.25007 6.34223 8.21886 6.38872 8.17949 6.42777L5.55947 9.04779C5.52027 9.087 5.47373 9.1181 5.42251 9.13932C5.37129 9.16054 5.31639 9.17146 5.26095 9.17146C5.20551 9.17146 5.15061 9.16054 5.09939 9.13932C5.04817 9.1181 5.00164 9.087 4.96244 9.04779L2.72839 6.81375C2.68918 6.77455 2.65808 6.72801 2.63686 6.67679C2.61564 6.62557 2.60472 6.57067 2.60472 6.51523C2.60472 6.45979 2.61564 6.40489 2.63686 6.35367C2.65808 6.30245 2.68918 6.25591 2.72839 6.21672ZM6.93134 5.16143C6.99396 5.16143 7.05517 5.14286 7.10723 5.10807C7.15929 5.07329 7.19987 5.02384 7.22383 4.96599C7.24779 4.90814 7.25406 4.84449 7.24185 4.78308C7.22963 4.72167 7.19948 4.66525 7.1552 4.62098C7.11093 4.5767 7.05452 4.54655 6.99311 4.53434C6.9317 4.52212 6.86804 4.52839 6.81019 4.55235C6.75234 4.57631 6.7029 4.61689 6.66811 4.66895C6.63332 4.72102 6.61476 4.78223 6.61476 4.84484C6.61476 4.9288 6.64811 5.00933 6.70748 5.0687C6.76685 5.12807 6.84738 5.16143 6.93134 5.16143Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1494_2789"
          x1="0.868343"
          y1="5.64423"
          x2="11.2885"
          y2="5.64423"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9262F7" />
          <stop offset="1" stopColor="#713FDC" />
        </linearGradient>
      </defs>
    </svg>
  );
};
